import { SearchBox } from '@mapbox/search-js-react';
import { LocationData } from '../services/eventService';

interface MapboxGeocoderProps {
  placeholder?: string;
  onLocationSelect: (location: LocationData) => void;
  initialValue?: string;
  className?: string;
}

export function MapboxGeocoder({ 
  placeholder = "Search for a location...", 
  onLocationSelect,
  initialValue = '',
  className = ""
}: MapboxGeocoderProps) {

  const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || 
    'pk.eyJ1IjoiamxhYm9yZGUiLCJhIjoiY21lN2ZjdnpkMDN6eTJscHY5MGx5ZGJnOCJ9.EA2QwsQS0qydRCBeu4vXmQ';

  if (!MAPBOX_ACCESS_TOKEN) {
    return (
      <div className={`input-field bg-yellow-50 border-yellow-200 text-yellow-800 ${className}`}>
        <span>⚠️ Mapbox configuration required</span>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <SearchBox
        accessToken={MAPBOX_ACCESS_TOKEN}
        onRetrieve={(result) => {
          console.log(result)
          if (result) {
            const locationData: LocationData = {
              address: result.features?.[0]?.properties.full_address || result.features?.[0]?.properties?.place_formatted || 'Unknown location',
              name: result.features?.[0]?.properties.name || 'Unknown location',
              coordinates: {
                latitude: result.features?.[0]?.geometry?.coordinates[1],
                longitude: result.features?.[0]?.geometry?.coordinates[0]
              },
              city: result.features?.[0]?.properties.context?.place?.name || 'Unknown city'
            };
            onLocationSelect(locationData);
          }
        }}
        options={{
          language: 'en',
          limit: 5,
          country: 'US',
        }}
        placeholder={placeholder}
        theme={{
          variables: {
            fontFamily: 'Inter, system-ui, sans-serif',
            padding: '12px 16px',
            borderRadius: '12px',
            border: '1px solid #d1d5db'
          }
        }}
      />
    </div>
  );
}